const scrollToFirstFormErrorField = () => {
  let hH = $('.main-header__sticky-wrapper').outerHeight(),
    errorField = $('.form-item-wrap.error'),
    finalOffset = errorField.eq(0).offset().top - hH - 45;
  $('html, body').animate({ scrollTop: finalOffset }, 250);
};

const scrollToFirstErrorNotification = () => {
  let hH = $('.main-header__sticky-wrapper').outerHeight(),
    errorField = $('.banner--alert'),
    finalOffset = errorField.eq(0).offset().top - hH - 45;
  $('html, body').animate({ scrollTop: finalOffset }, 250);
};
